import React from 'react';

import { BRAND_NAME, TAGLINE } from '../../config/brand';

/**
 * The keepr mark: the index-card tab, in the one brand pink. Inline SVG so
 * it scales crisply from a 16px favicon to a 72px app icon and picks the
 * action token up wherever it renders.
 *
 *   <BrandMark size={20} />
 */
export function BrandMark({ size = 20, className = '', title }) {
	return (
		<svg
			className={['brand-mark', className].filter(Boolean).join(' ')}
			width={size}
			height={size}
			viewBox="0 0 72 72"
			xmlns="http://www.w3.org/2000/svg"
			role={title ? 'img' : undefined}
			aria-label={title}
			aria-hidden={title ? undefined : 'true'}
			focusable="false"
		>
			<path
				d="M6 26a8 8 0 0 1 8-8h14a8 8 0 0 1 6.4 3.2l3.2 4.3a8 8 0 0 0 6.4 3.2H58a8 8 0 0 1 8 8v19a8 8 0 0 1-8 8H14a8 8 0 0 1-8-8Z"
				fill="var(--action, #EC1A81)"
			/>
			<path d="M15 45h28" stroke="var(--on-action, #fff)" strokeWidth="5" strokeLinecap="round" opacity=".85" />
			<path d="M15 54h18" stroke="var(--on-action, #fff)" strokeWidth="5" strokeLinecap="round" opacity=".5" />
		</svg>
	);
}

/**
 * Mark left of wordmark, always: never stacked, and the wordmark is ink
 * (the pink has one job — the mark and the actions). Sizes default to the
 * rail's lockup (20px mark, 17px wordmark).
 */
export function BrandLockup({ markSize = 20, wordmarkSize = 17, className = '' }) {
	return (
		<span className={['brand-lockup', className].filter(Boolean).join(' ')}>
			<BrandMark size={markSize} />
			<span className="brand-lockup__wordmark" style={{ fontSize: wordmarkSize }}>{BRAND_NAME}</span>
		</span>
	);
}

/**
 * The public pages' lead (sign in, register): the lockup over the tagline.
 * The tagline never renders inside the authenticated app.
 */
export function BrandHero({ className = '' }) {
	return (
		<div className={['brand-hero', className].filter(Boolean).join(' ')}>
			<BrandLockup markSize={36} wordmarkSize={30} />
			<p className="brand-hero__tagline">{TAGLINE}</p>
		</div>
	);
}
